import { useState, useEffect } from "react";
import "../styling/BookABooth.css";
import BookingHeader from "./clientPortal/BookingHeader";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import Select from "react-select";

const BookABooth2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Instantly jump to top on mount
  }, []);

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #ccc",
      boxShadow: "none",
      height: "50px",
      fontSize: "15px",
      marginTop: "10px",
    }),
  };

  const navigate = useNavigate();
  const location = useLocation();
  const event = location.state?.event;
  const message = location.state?.message;
  const eventId = location.state?.event._id;
  const businessId = event.businessId;

  const CLIENT_HOME_URL = `https://beta.boothbloom.com/client-home?businessId=${businessId}`;

  useEffect(() => {
    if (message) {
      alert(message);
    }
  }, []);

  const optionsDate = { month: "2-digit", day: "2-digit", year: "2-digit" };
  const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: true };

  const eventDate = new Date(event.eventDate);
  const startTime = new Date(event.startTime);
  const endTime = new Date(event.endTime);

  const [chosenPackage, setChosenPackage] = useState(null);
  const [addons, setAddons] = useState([]);

  const [showPolicyModal, setShowPolicyModal] = useState(false);

  const toggleModal = () => {
    setShowPolicyModal(!showPolicyModal);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      width: "90%",           
      maxWidth: "730px",      
      height: "auto",         
      maxHeight: "90vh",      
      
      background: "#FFFFFF",
      boxShadow: "0px 3px 12px #00000029",
      borderRadius: "5px",
      padding: "30px",        
      position: "relative",
      overflowY: "auto",      
      fontFamily: "Poppins, sans-serif",
      boxSizing: "border-box",
      
      WebkitOverflowScrolling: "touch", 
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "20px"
    },
    title: {
      color: "#000000",
      fontSize: "24px",
      fontWeight: "600",
      margin: 0
    },
    closeIcon: {
      cursor: "pointer"
    },
    body: {
      color: "#4D4D4D",
      fontSize: "14px",
      lineHeight: "1.6"
    },
    section: {
      marginBottom: "24px"
    },
    subHeading: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: "15px",
      fontWeight: "500",      
      lineHeight: "24px",     
      color: "#4D4D4D",       
      letterSpacing: "0px",
      textAlign: "left",
      
      marginTop: "20px",      
      marginBottom: "0px",
      display: "block",
    },
  };

  const convertToTimeInputValue = (isoString) => {
    const date = new Date(isoString);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    const pad = (num) => (num < 10 ? "0" + num : num);

    return `${pad(hours)}:${pad(minutes)}`;
  };

  const [editMode, setEditMode] = useState(false);
  const [updatedEvent, setUpdatedEvent] = useState({
    eventName: event.eventName,
    eventType: event.eventType,
    eventDate: event.eventDate?.split("T")[0],
    startTime: convertToTimeInputValue(event.startTime),
    endTime: convertToTimeInputValue(event.endTime),
    address: event.address,
    details: event.details,
  });


  const handleInputChange = (field, value) => {
    setUpdatedEvent((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    const {
      eventDate,
      startTime,
      endTime,
      eventName,
      eventType,
      address,
      details,
    } = updatedEvent;

    if (
      !eventDate ||
      !startTime ||
      !endTime ||
      !eventName.trim() ||
      !eventType.trim() ||
      !address.trim()
    ) {
      alert("Please fill in all the fields before saving.");
      return; 
    }

    try {
      const isoEventDate = new Date(`${eventDate}T${startTime}`).toISOString();
      const isoStartTime = new Date(`${eventDate}T${startTime}`).toISOString();
      const isoEndTime = new Date(`${eventDate}T${endTime}`).toISOString();

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/client/edit-event`,
        {
          eventId: event._id,
          eventName,
          eventType,
          address,
          details,
          eventDate: isoEventDate,
          startTime: isoStartTime,
          endTime: isoEndTime,
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        alert("Event updated successfully.");
        setEditMode(false);
      } else {
        alert("Update failed.");
      }
    } catch (error) {
      console.error(error);
      alert("An error occurred while updating the event.");
    }
  };

  const fetchPackage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getPackageDetail/${event.packageId}`,
        { withCredentials: true }
      );
      setChosenPackage(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAddons = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/business/getAddonDetail/${eventId}`,
        { withCredentials: true }
      );

      setAddons(response.data.addons);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancelEvent = async () => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/cancelEvent/${eventId}`,
        {
          withCredentials: true,
        }
      );

      alert("Event cancelled successfully.");
      window.location.href = CLIENT_HOME_URL;
    } catch (error) {
      console.error("Cancel failed:", error);
      alert(error.response?.data?.message || "Failed to cancel event.");
    }
  };

  useEffect(() => {
    if (event?.packageId) {
      fetchPackage();
      fetchAddons();
    }
  }, [event]);

  const options = [
    { value: "wedding", label: "Wedding" },
    { value: "corporate", label: "Corporate" },
    { value: "birthday", label: "Birthday" },
    { value: "others", label: "Others" },
  ];

  console.log("Chosen Package:", chosenPackage);
  console.log("Addons:", addons);

  const handleBookClick = async () => {
    if (!chosenPackage) {
      alert("Package details not loaded yet.");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/client/create-checkout-session`, 
        { eventId: event._id },
        { withCredentials: true } 
      );

      const checkoutUrl = response.data.data.url;
      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      } else {
        alert("Payment URL not generated. Please contact support.");
      }
    } catch (error) {
      console.error("Failed to initiate payment:", error.response?.data?.message || error.message);
      alert(error.response?.data?.message || "Failed to connect to the payment gateway. Please ensure the vendor has connected their bank account.");
    }
  };


  const packages = (
    <div>
      <div
        className="invoiceContent"
        style={{
          width: "90.25%",
          background: "#FFFFFF",
          height: "fitContent",
        }}
      >
        <h2
          style={{ color: "#1C1154", marginTop: "0px", marginBottom: "30px" }}
        >
          Choosen Package
        </h2>
        <div
          className="right-panel-content"
          style={{ marginTop: "0px", padding: "20px" }}
        >
          <div className="right-panel-arrow-container">
            <span>
              <h2
                style={{
                  color: "#1C1154",
                  marginTop: "0px",
                  marginBottom: "5px",
                  fontWeight: "425",
                }}
              >
                {chosenPackage?.name || ""}
              </h2>
            </span>{" "}
            <h4
              style={{
                alignSelf: "flex-end",
                marginRight: "10px",
                marginBottom: "5px",
                color: "#1C1154",
                fontWeight: "425",
                marginTop: "auto",
              }}
            >
              $ {chosenPackage?.cost || ""}
            </h4>
          </div>

          <div style={{ color: "#625C73" }}>
            {/* Simple \n split mapping, preserving all text exactly as typed */}
            {(chosenPackage?.description || "").split("\n").map((feature, i) => (
              <p key={i} style={{ marginBottom: "3px", marginTop: "3px" }}>
                {feature}
              </p>
            ))}
          </div>
        </div>

        {Array.isArray(addons) &&
          addons.length > 0 &&
          addons.map((addon) => (
            <div
              key={addon._id}
              className="bordered-box"
              style={{ marginBottom: "10px", marginTop: "20px" }}
            >
              <div className="content">
                <div style={{ color: "#1C1154" }}>{addon.name}</div>
                {/* Simple \n split mapping for addons */}
                <div style={{ color: "#625C73", marginTop: "7px", marginBottom: "5px" }}>
                  {(addon?.description || "").split("\n").map((feature, i) => (
                    <p key={i} style={{ margin: "3px 0" }}>
                      {feature}
                    </p>
                  ))}
                </div>
              </div>
              <div>
                <p
                  className="rightmost-content"
                  style={{ marginTop: "-20px", color: "#1C1154" }}
                >
                  ${addon.cost}
                </p>
              </div>
            </div>
          ))}
      </div>
      <div
        style={{
          backgroundColor: "#ffffff",
          width: "83.8%",
          border: "1px solid #D9D9D9",
          marginTop: "35px",
          padding: "8%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <h2 style={{ color: "#1C1154", fontWeight: "450", marginTop: "0px" }}>
          Event Info
        </h2>

        {/* Single button toggles edit/save */}
        <button
          onClick={() => {
            if (editMode) {
              handleSave();
            } else {
              setEditMode(true);
            }
          }}
          style={{
            position: "absolute",
            top: "25px",
            right: "25px",
            fontSize: "14px",
            padding: "6px 12px",
            border: "1px solid #D4D4D4",
            backgroundColor: "#FfFfFf",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            userSelect: "none",
          }}
        >
          {editMode ? (
            "Save"
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                width="16"
                fill="#1C1154"
                viewBox="0 0 24 24"
                stroke="#1C1154"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 20h9" />
                <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
              </svg>
              Edit
            </>
          )}
        </button>

        <input
          placeholder="Event Name"
          value={updatedEvent.eventName}
          readOnly={!editMode}
          onChange={(e) => handleInputChange("eventName", e.target.value)}
          style={{
            border: "1px solid #D4D4D4",
            fontSize: "15px",
            width: "100%",
            height: "50px",
            marginTop: "0px",
            backgroundColor: "#ffffff",
            paddingLeft: "10px",
            boxSizing: "border-box",
            color: "#625C73",
            fontFamily: "poppins"
          }}
        />

        {editMode ? (
          <Select
            options={options}
            styles={customStyles}
            components={{
              IndicatorSeparator: () => null,
            }}
            onChange={(selectedOption) =>
              setUpdatedEvent((prevData) => ({
                ...prevData,
                eventType: selectedOption.value,
              }))
            }
            value={options.find(
              (option) => option.value === updatedEvent.eventType
            )}
            name="eventType"
            id="eventType"
          />
        ) : (
          <input
            value={
              options.find((opt) => opt.value === updatedEvent.eventType)
                ?.label || updatedEvent.eventType
            }
            readOnly
            style={{
              border: "1px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              height: "50px",
              marginTop: "10px",
              backgroundColor: "#ffffff",
              paddingLeft: "10px",
              boxSizing: "border-box",
              color: "#625C73",
              fontFamily: "poppins"
            }}
          />
        )}

        <input
          type="date"
          value={updatedEvent.eventDate}
          readOnly={!editMode}
          onChange={(e) => handleInputChange("eventDate", e.target.value)}
          style={{
            border: "1px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
            height: "50px",
            marginTop: "10px",
            backgroundColor: "#ffffff",
            paddingLeft: "10px",
            boxSizing: "border-box",
            color: "#625C73",
            fontFamily: "poppins"
          }}
        />

        {/* Time inputs with fixed combined width matching other inputs */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px",
            width: "100%",
            boxSizing: "border-box",
            gap: "8px",
          }}
        >
          <input
            value={updatedEvent.startTime}
            readOnly={!editMode}
            type="time"
            onChange={(e) => handleInputChange("startTime", e.target.value)}
            style={{
              border: "1px solid #D9D9D9",
              fontSize: "15px",
              width: "calc(50% - 20px)", 
              height: "50px",
              backgroundColor: "#ffffff",
              paddingLeft: "10px",
              boxSizing: "border-box",
              color: "#625C73",
              fontFamily: "poppins"
            }}
          />

          <span
            style={{
              width: "40px",
              textAlign: "center",
              fontSize: "15px",
              color: "#555",
              userSelect: "none",
            }}
          >
            to
          </span>

          <input
            value={updatedEvent.endTime}
            readOnly={!editMode}
            type="time"
            onChange={(e) => handleInputChange("endTime", e.target.value)}
            style={{
              border: "1px solid #D9D9D9",
              fontSize: "15px",
              width: "calc(50% - 20px)", 
              height: "50px",
              backgroundColor: "#ffffff",
              paddingLeft: "10px",
              boxSizing: "border-box",
              color: "#625C73",
            }}
          />
        </div>

        <input
          placeholder="Address"
          value={updatedEvent.address}
          readOnly={!editMode}
          onChange={(e) => handleInputChange("address", e.target.value)}
          style={{
            border: "1px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
            height: "50px",
            marginTop: "10px",
            backgroundColor: "#ffffff",
            paddingLeft: "10px",
            boxSizing: "border-box",
            color: "#625C73",
            padding: '10px'
          }}
        />

        <textarea
          placeholder="Details"
          value={updatedEvent.details}
          readOnly={!editMode}
          onChange={(e) => handleInputChange("details", e.target.value)}
          style={{
            border: "1px solid #D9D9D9",
            fontSize: "15px",
            width: "100%",
            height: "120px",
            marginTop: "10px",
            backgroundColor: "#ffffff",
            padding: "10px",
            boxSizing: "border-box",
            color: "#625C73",
            fontWeight: '400'
          }}
        />
      </div>
      <div
        style={{
          backgroundColor: "#ffffff",
          width: "83.8%",
          border: "1px solid #D9D9D9",
          marginTop: "35px",
          padding: "8%",
        }}
      >
        <h2 style={{ color: "#1C1154", fontWeight: "450", marginTop: "0px" }}>
          {" "}
          Cancellation Policy
        </h2>
        <div style={{ color: "#625C73", padding: "10px", display: "flex" }}>
          <p>
            Free cancellation before Dec 15. Cancel before check-in on Dec 20
            for a partial refund.{" "}
            <span style={{ color: "#1C1154", cursor: "pointer" }} onClick={toggleModal} >Learn more</span>{" "}
          </p>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#ffffff",
          width: "83.8%",
          border: "1px solid #D9D9D9",
          marginTop: "35px",
          padding: "8%",
        }}
      >
        <h2
          style={{
            color: "#1C1154",
            fontWeight: "450",
            marginTop: "0px",
            marginBottom: "0px",
          }}
        >
          {" "}
          Make Payment
        </h2>
        <div style={{ color: "#625C73", padding: "10px", display: "flex" }}>
          <p>
            By selecting the button, I agree to the booking terms. I also agree
            to the updated Terms of Service, Payments Terms of Service, and I
            acknowledge the Privacy Policy.
          </p>
        </div>
        <div>
          <button
            style={{
              marginTop: "15px",
              height: "40px",
              width: "100%",
              background: "#260F99",
              border: "1px solid #43425D ",
              color: "#FFFFFF",
              fontSize: "17px",
              fontWeight: "450",
            }}
            onClick={handleBookClick}
          >
            Book Your Booth
          </button>
        </div>
      </div>
    </div>
  );

  const boothRightPanel = (
    <div
      className="invoiceContent"
      style={{
        width: "87.7%",
        background: "#FFFFFF",
        marginTop: "30px",
        borderLeft: "hidden",
        borderRight: "hidden",
        borderBottom: "hidden",
        height: "auto",
      }}
    >
      <div
        className="right-panel-content"
        style={{ marginTop: "0px", padding: "20px" }}
      >
        <div className="right-panel-arrow-container">
          <span>
            <h4
              style={{
                color: "#1C1154",
                marginTop: "0px",
                marginBottom: "5px",
                fontWeight: "425",
              }}
            >
              {chosenPackage?.name || ""}
            </h4>
          </span>
          <h4
            style={{
              alignSelf: "flex-end",
              marginRight: "10px",
              marginBottom: "5px",
              color: "#1C1154",
              fontWeight: "425",
              marginTop: "auto",
            }}
          >
            $ {chosenPackage?.cost || ""}
          </h4>
        </div>
      </div>

      {Array.isArray(addons) &&
        addons.length > 0 &&
        addons.map((addon) => (
          <div
            className="right-panel-content"
            style={{ marginTop: "20px", padding: "20px" }}
            key={addon._id}
          >
            <div className="right-panel-arrow-container">
              <span>
                <h4
                  style={{
                    color: "#1C1154",
                    marginTop: "0px",
                    marginBottom: "5px",
                    fontWeight: "425",
                  }}
                >
                  {addon.name}
                </h4>
              </span>

              <h4
                style={{
                  alignSelf: "flex-end",
                  marginRight: "10px",
                  marginBottom: "5px",
                  color: "#1C1154",
                  fontWeight: "425",
                  marginTop: "auto",
                }}
              >
                ${addon.cost}
              </h4>
            </div>
          </div>
        ))}

      <div
        className="right-panel-content"
        style={{ marginTop: "20px", padding: "10px" }}
      >
        <div className="right-panel-arrow-container">
          <p
            style={{
              color: "#625C73",
              marginTop: "0px",
              marginBottom: "5px",
              fontWeight: "425",
            }}
          >
            {event.eventDate.split("T")[0]}
          </p>
        </div>
      </div>
      <div
        className="right-panel-content"
        style={{ marginTop: "20px", padding: "10px" }}
      >
        <div className="right-panel-arrow-container">
          <p
            style={{
              color: "#625C73",
              marginTop: "0px",
              marginBottom: "5px",
              fontWeight: "425",
            }}
          >
            {startTime.toLocaleTimeString("en-US", optionsTime) +
              " - " +
              endTime.toLocaleTimeString("en-US", optionsTime)}
          </p>
        </div>
      </div>

      <div
        className="right-panel-content"
        style={{ marginTop: "20px", padding: "10px" }}
      >
        <div className="right-panel-arrow-container">
          <p
            style={{
              color: "#625C73",
              marginTop: "0px",
              marginBottom: "5px",
              fontWeight: "425",
            }}
          >
            {event.address}
          </p>
        </div>
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", color: "#625C73" }}
      >
        <p>You won’t be charged yet</p>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#625C73",
        }}
      >
        <div> {chosenPackage?.name || ""}</div>
        <div> $ {chosenPackage?.cost || ""}</div>
      </div>

      {addons?.map((addon) => (
        <div
          key={addon._id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            color: "#625C73",
            marginTop: "10px",
          }}
        >
          <div>{addon.name}</div>
          <div style={{ marginBottom: "5px" }}>${addon.cost}</div>
        </div>
      ))}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          color: "#1C1154", // blue shade used earlier
          marginTop: "12px",
          fontWeight: "700",
          borderTop: "1px solid #D9D9D9",
          borderBottom: "1px solid #D9D9D9",
          paddingTop: "8px",
        }}
      >
        <div>Total</div>
        <div>${event.expPaymentAmount}</div>
      </div>
      <button
        style={{
          marginTop: "35px",
          height: "40px",
          width: "100%",
          background: "#260F99",
          border: "1px solid #43425D ",
          color: "#FFFFFF",
          fontSize: "17px",
          fontWeight: "450",
          cursor: "pointer",
        }}
        onClick={handleBookClick}
      >
        Book Your Booth
      </button>
    </div>
  );

  return (
    <div>
    <BookingHeader />
    {/* Apply the main flex container class here */}
    <div className="bookAbooth" style={{marginTop : "50px"}}>
      {/* Apply the left panel class */}
      <div className="left-panel" style={{ marginTop: "45px" }}>
        {packages}
      </div>

      {/* Apply the right panel sticky class */}
      <div className="right-panel-sticky" style={{ marginTop: "45px" }}>
        {boothRightPanel}
      </div>
    </div>
    {showPolicyModal && (
  <div style={modalStyles.overlay}>
    <div style={modalStyles.modal}>
      <div style={modalStyles.header}>
        <h2 style={modalStyles.title}>Cancellation Policy</h2>
        <span style={modalStyles.closeIcon} onClick={toggleModal}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1C1154" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </span>
      </div>
      
      <div style={modalStyles.body}>
        <section style={modalStyles.section}>
          <h4 style={modalStyles.subHeading}>1. Cancellation Notice:</h4>
          <p style={{ marginTop: "0px" }}>Cancellations must be made by direct phone call or email to vendor. Cancellations are accepted until the day before your event. A cancellation is considered effective on the date we receive your written notice.</p>
        </section>

        <section style={modalStyles.section}>
          <h4 style={modalStyles.subHeading}>2. Nonrefundable Deposit:</h4>
          <p style={{ marginTop: "0px" }} >Please note that your initial deposit is nonrefundable. This deposit secures your booking date and is not eligible for a refund under any circumstances.</p>
        </section>

        <section style={modalStyles.section}>
          <h4 style={modalStyles.subHeading}>3. Rescheduling:</h4>
          <p style={{ marginTop: "0px" }} >If you need to reschedule your event, please notify us as soon as possible. We will do our best to accommodate your new date, subject to availability. No additional rescheduling fee will be charged; however, your initial deposit will be applied as a fee for the rescheduled date.</p>
        </section>

        <section style={modalStyles.section}>
          <h4 style={modalStyles.subHeading}>4. Force Majeure:</h4>
          <p style={{ marginTop: "0px" }} >In the event of unforeseen circumstances beyond your control (e.g., natural disasters, government restrictions), we will work with you to reschedule the event or offer alternative solutions, depending on the situation.</p>
        </section>

        <section style={modalStyles.section}>
          <h4 style={modalStyles.subHeading}>5. Vendor Cancellation:</h4>
          <p style={{ marginTop: "0px" }} >If vendor needs to cancel your booking due to unforeseen circumstances, we will provide a full refund of all payments made, excluding the nonrefundable deposit, or offer an alternative date, subject to your approval.</p>
        </section>

        <section style={modalStyles.section}>
          <h4 style={modalStyles.subHeading}>6. No-Show Policy:</h4>
          <p style={{ marginTop: "0px" }} >If the photobooth is unable to be set up due to the client’s failure to provide necessary access or information, the full booking amount will be forfeited. By booking, you agree to the terms outlined in this cancellation policy.</p>
        </section>
      </div>
    </div>
  </div>
)}
  </div>
  );
};

export default BookABooth2;